







































import {Emit} from 'vue-property-decorator';
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Vente} from '@/models';

import CrudVenteEdit from '@/components/Crud/Vente/Edit.vue';

@Component({
	components: {
		CrudVenteEdit,
	}
})
export default class CrudVenteEditDialog extends Vue {
	@InOut({ type: Vente  , isVModel: true }) private value!: Vente;

	@Emit()
	private onSubmit(vente: Vente) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}
}
